import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-create-slider',
  templateUrl: './create-slider.component.html',
  styleUrls: ['./create-slider.component.scss']
})
export class CreateSliderComponent implements OnInit, AfterViewInit {
  @Input() bannerInfo: any;
  fileImg64: any;
  urlImgLogo: string;
  wrongSize: any;
  bannerForm: FormGroup;
  reference: number;
  // flags
  // isRentMax = false;
  // isRent = false;

  // Dictionary to map ranges to dimensions
  imageDimensionsMap: { [key: string]: ImageDimensions } = {
    "1-10": { width: 1200, height: 800 },
    "fondos-e-inversion": { width: 1400, height: 400 },
    "rentas-vitalicias": { width: 1400, height: 400 },
  };
  dimensions: ImageDimensions;

  fileImg64Mobile: any;
  wrongSizeMobile: any;

  imageDimensionsMapMobile: { [key: string]: ImageDimensions } = {
    // "1-10": { width: 1200, height: 800 },
    "fondos-e-inversion": { width: 325, height: 380 },
    "rentas-vitalicias": { width: 325, height: 380 },
  };
  dimensionsMobile: ImageDimensions;
  maxLength: number;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    // private router: Router
  ) {
  }

  ngOnInit(): void {
    this.reference = this.bannerInfo.reference;
    this.dimensions = this.getImageDimensions(this.reference);
    this.dimensionsMobile = this.getImageDimensionsMobile(this.reference);
    this.createForm2();
    // if (this.router.url.includes('rent-investment')) {
    //   this.isRentMax = true;
    // }

    // if (this.router.url.includes('rent') || this.router.url.includes('about-us')) {
    //   this.isRent = true;
    //   this.bannerForm.get('validate').value === 1 ? this.bannerForm.get('urlButton1').disable() : this.bannerForm.get('urlButton1').enable();
    // }
  }

  ngAfterViewInit(): void {
    this.updateForm2();
  }

  sendData(): any {
    const dataToSend = {
      ...this.bannerForm.value,
      reference: this.reference,
      // nameButton2: '',
      // urlButton2: '',
      // typeIdCategoryId: 0,
      // nameButton3: '',
      // nameButton4: '',
      // urlButton3: '',
      // urlButton4: '',
      // img2: '',
      // img642: '',
      // img3: '',
      // img643: '',
      // img4: '',
      // img644: '',
    };
    // if (!this.router.url.includes('rent-investment')) {
    //   delete dataToSend.url1;
    //   delete dataToSend.url2;
    //   delete dataToSend.url3;
    //   delete dataToSend.texto1;
    //   delete dataToSend.texto2;
    //   delete dataToSend.texto3;
    // }

    // if (!this.router.url.includes('rent')) {
    //   delete dataToSend.validate;
    // }
    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.bannerForm = this.fb.group({
      title: ['', Validators.required],
      title2: [this.bannerInfo ? this.bannerInfo.title2 : ''],
      order: [null, Validators.required],
      nameButton1: [this.bannerInfo ? this.bannerInfo.button1 : '', Validators.required],
      img: ['', Validators.required],
      img64: ['', Validators.required],
      subTitle: ['', Validators.required],
      subTitle2: [''],
      urlButton1: ['', Validators.required],
      nameButton5: [null],
      urlButton5: [null],
      nameButton6: [null],
      urlButton6: [null],
      nameButton7: [null],
      urlButton7: [null],
      validate: [null]
    });

    if (this.reference == 7) {
      this.bannerForm.get('title2').setValue('assets/images/benefits/vidaplus.png');
      this.urlImgLogo = this.bannerForm.get('title2').value;

      const title2Control = this.bannerForm.get('title2');
      title2Control.setValidators([Validators.required]);
      title2Control.updateValueAndValidity();
      const button1Control = this.bannerForm.get('nameButton1');
      button1Control.setValidators([Validators.required]);
      button1Control.updateValueAndValidity();

      const titleControl = this.bannerForm.get('title');
      titleControl.setValidators([Validators.required]);
      titleControl.clearValidators();
      const subTitleControl = this.bannerForm.get('subTitle');
      subTitleControl.setValidators([Validators.required]);
      subTitleControl.clearValidators();
      const urlButton1Control = this.bannerForm.get('urlButton1');
      urlButton1Control.setValidators([Validators.required]);
      urlButton1Control.clearValidators();

    }
    //
    // if (this.router.url.includes('rent-investment')) {
    //   this.bannerForm.get('nameButton5').setValue(this.bannerInfo.button5);
    //   this.bannerForm.get('nameButton6').setValue(this.bannerInfo.button6);
    //   this.bannerForm.get('nameButton7').setValue(this.bannerInfo.button7);
    //   this.bannerForm.get('urlButton5').setValue(this.bannerInfo.url5);
    //   this.bannerForm.get('urlButton6').setValue(this.bannerInfo.url6);
    //   this.bannerForm.get('urlButton7').setValue(this.bannerInfo.url7);
    // }

    // if (this.router.url.includes('rent')) {
    //   this.bannerForm.get('validate').setValue(this.bannerInfo.validate);
    //   this.bannerForm.get('validate').setValidators([Validators.required]);
    // }
  }

  private createForm2(): any {
    this.bannerForm = this.fb.group({
      typeId: [0],
      img: ['', Validators.required],
      img64: ['', Validators.required],
      title: [''],
      title2: [''],
      subTitle: [''],
      subTitle2: [''],
      nameButton1: [''],
      nameButton2: [''],
      urlButton1: [''],
      urlButton2: [''],
      validate: [0],
      typeIdCategoryId: [0],
      nameButton3: [''],
      nameButton4: [''],
      urlButton3: [''],
      urlButton4: [''],
      img2: [''],
      img642: [''],
      img3: [''],
      img643: [''],
      img4: [''],
      img644: [''],
      order: [0],
      nameButton5: [''],
      urlButton5: [''],
      nameButton6: [''],
      urlButton6: [''],
      nameButton7: [''],
      urlButton7: ['']
    });

    if ([16, 17, 18].includes(this.reference)) {
      this.maxLength = 300;
    }
  }

  private updateForm2(): any { // TODO JSCJ ??? PARA QUE SE USA?
    if (this.reference === 1) {
    }
    if ([2, 4, 5, 6, 11, 12, 13, 14, 15, 16, 17, 18].includes(this.reference)) {
      this.bannerForm.get('validate').setValue(1);
    }
    if (this.reference === 3) {
    }
    if (this.reference === 5) {
      this.urlImgLogo = this.bannerForm.get('title2').value;
    }
    if (this.reference === 7) {
      this.bannerForm.get('title2').setValue('assets/images/benefits/vidaplus.png');
      this.urlImgLogo = this.bannerForm.get('title2').value;
    }
    if (this.reference === 9) {

    }
  }

  // (image.width == this.dimensions.width && image.height == this.dimensions.height)
  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (
          ((this.reference >= 1 && this.reference <= 10 && this.reference != 6) && (image.width <= this.dimensions.width && image.height <= this.dimensions.height)) ||
          (!(this.reference >= 1 && this.reference <= 10 && this.reference != 6) && (image.width == this.dimensions.width && image.height == this.dimensions.height))
        ) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.bannerForm.get('img').setValue((event.target.files[0]).name);
          this.bannerForm.get('img64').setValue(this.fileImg64.split(',')[1]);
        } else {
          this.wrongSize = `Resolución de imagen no permitida (requerida: ${this.dimensions.width}px x ${this.dimensions.height}px)`;
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  getBase64Mobile(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width == this.dimensionsMobile.width && image.height == this.dimensionsMobile.height) {
          this.wrongSizeMobile = null;
          this.fileImg64Mobile = image.src;
          this.bannerForm.get('img2').setValue((event.target.files[0]).name);
          this.bannerForm.get('img642').setValue(this.fileImg64Mobile.split(',')[1]);
        } else {
          this.wrongSizeMobile = `Resolución de imagen no permitida (requerida: ${this.dimensionsMobile.width}px x ${this.dimensionsMobile.height}px)`;
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }
  title2KeyUp(event: any) {
    if (this.reference !== 7) {
      return;
    }
    this.urlImgLogo = this.bannerForm.get('title2').value ? this.bannerForm.get('title2').value : 'assets/images/benefits/vidaplus.png';
  }

  // Function to get dimensions based on ID
  getImageDimensions(id: number): ImageDimensions | undefined {
    if (id >= 1 && id <= 10 && id != 6) {
      return this.imageDimensionsMap["1-10"];
    } else if ((id >= 11 && id <= 15) || id == 6) {
      return this.imageDimensionsMap["fondos-e-inversion"];
    } else if (id >= 16 && id <= 18) {
      return this.imageDimensionsMap["rentas-vitalicias"];
    }
    return undefined; // Return undefined for IDs outside the specified ranges
  }

  getImageDimensionsMobile(id: number): ImageDimensions | undefined {
    // if (id >= 1 && id <= 10) {
    //   return this.imageDimensionsMap["1-10"];
    if ((id >= 11 && id <= 15) || id == 6) {
      return this.imageDimensionsMapMobile["fondos-e-inversion"];
    } else if (id >= 16 && id <= 18) {
      return this.imageDimensionsMapMobile["rentas-vitalicias"];
    }
    // return undefined; // Return undefined for IDs outside the specified ranges
  }
}

type ImageDimensions = {
  width: number;
  height: number;
};
